<template>
  <p>Loging you out...</p>
</template>

<script>
import { mapState } from 'vuex'
import AdminDashboard from '@/components/admin/AdminDashboard'
import UserDashboard from '@/components/user/UserDashboard'
export default {
  name: 'Logout',
  mounted() {
    this.$store.dispatch('logout')
  },
}
</script>

<style scoped></style>
